import React, {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {formatDateTime} from '../shared/DocumentApi'
import {getCandidateInterviews} from './Api'
import {
  HR_INTERVIEW_PATH,
  IInterviewModel,
  INTERVIEW_STATUS_BADGE,
  INTERVIEW_STATUS_LABEL,
  interviewTimeRange,
} from './InterviewModel'

/** Künyedeki mülakat geçmişi: planlanan zaman, gerçekleşme tarihi, iptal sebebi ve notlar */
export const CandidateInterviews: FC<{candidateId: string}> = ({candidateId}) => {
  const [interviews, setInterviews] = useState<IInterviewModel[]>([])
  const [loading, setLoading] = useState(true)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    setLoading(true)
    setFailed(false)
    getCandidateInterviews(candidateId)
      .then(({data}) => setInterviews(data.payload))
      .catch(() => setFailed(true))
      .finally(() => setLoading(false))
  }, [candidateId])

  return (
    <div className='card'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title fw-bolder'>Mülakatlar</h3>
        <div className='card-toolbar'>
          <Link to={HR_INTERVIEW_PATH} className='btn btn-sm btn-light'>
            Tüm Mülakatlar
          </Link>
        </div>
      </div>
      <div className='card-body pt-0'>
        {loading ? (
          <div className='text-center py-6'>
            <span className='spinner-border spinner-border-sm text-primary' />
          </div>
        ) : failed ? (
          <div className='text-danger py-6 text-center'>Mülakatlar yüklenemedi.</div>
        ) : interviews.length === 0 ? (
          <div className='text-muted py-6 text-center'>Bu aday için mülakat planlanmadı.</div>
        ) : (
          interviews.map((interview) => (
            <div key={interview.id} className='d-flex gap-4 py-4 border-bottom border-gray-200'>
              <i className='bi bi-calendar-event fs-2 text-primary'></i>
              <div className='d-flex flex-column flex-grow-1'>
                <div className='d-flex flex-wrap align-items-center gap-2'>
                  <span className={`badge ${INTERVIEW_STATUS_BADGE[interview.status]}`}>
                    {INTERVIEW_STATUS_LABEL[interview.status]}
                  </span>
                  <span className='fw-semibold'>{interview.title}</span>
                  <span className='text-muted fs-7 ms-auto'>{interview.organizerUserName}</span>
                </div>
                <div className='fs-7 mt-2'>
                  <span className='text-muted'>Planlanan: </span>
                  {interviewTimeRange(interview)}
                  {interview.jobTitle ? ` · ${interview.jobTitle}` : ''}
                </div>
                {interview.status === 'COMPLETED' && (
                  <div className='fs-7'>
                    <span className='text-muted'>Gerçekleşme: </span>
                    {formatDateTime(interview.completedAt)}
                  </div>
                )}
                {interview.status === 'CANCELLED' && (
                  <div className='fs-7'>
                    <span className='text-muted'>İptal sebebi: </span>
                    <span className='text-danger'>{interview.cancelReason}</span>
                    {interview.cancelledAt ? ` (${formatDateTime(interview.cancelledAt)})` : ''}
                  </div>
                )}
                {interview.participants.length > 0 && (
                  <div className='fs-7'>
                    <span className='text-muted'>Katılımcılar: </span>
                    {interview.participants.map((participant) => participant.name || participant.email).join(', ')}
                  </div>
                )}
                {(interview.notes || []).map((note) => (
                  <div key={note.id} className='bg-light rounded p-3 mt-2 fs-7'>
                    <div className='text-muted fs-8 mb-1'>
                      {note.authorName || '-'} · {formatDateTime(note.createdDate)}
                    </div>
                    <div style={{whiteSpace: 'pre-line'}}>{note.text}</div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
